import { render, staticRenderFns } from "./InspectionFormViewGlobal.vue?vue&type=template&id=8ffe73c4"
import script from "./InspectionFormViewGlobal.vue?vue&type=script&lang=js"
export * from "./InspectionFormViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports